





















export default {
	methods:{
		restart(){
			this.$emit("restart");
		}
	}
}
